import { CLEAR_SELECTED_UPSELLS, SET_UPSELL_OPTIONS, TOGGLE_UPSELL, UpsellAction } from '@store/actions';
import { IUpsell, UpsellType } from '@types';

export interface IUpsellState {
    options: IUpsell[];
    selected: UpsellType[];
}

export const initialState = {
    options: [],
    selected: [UpsellType.STANDARD],
};

export const MUTUALLY_EXCLUSIVE_UPSELLS = [UpsellType.STANDARD, UpsellType.ENHANCED, UpsellType.PROOF_OF_DELIVERY];

export const reducer = (state: IUpsellState = initialState, action: UpsellAction): IUpsellState => {
    const { type, payload } = action;

    switch (type) {
        case TOGGLE_UPSELL: {
            const current = payload as UpsellType;

            if (state.selected.includes(current)) {
                return {
                    ...state,
                    selected: state.selected.filter((item: UpsellType): boolean => item !== payload),
                };
            }

            let selected = state.selected as UpsellType[];

            if (MUTUALLY_EXCLUSIVE_UPSELLS.includes(current)) {
                selected = state.selected.filter((item: UpsellType): boolean => {
                    return !MUTUALLY_EXCLUSIVE_UPSELLS.includes(item);
                });
            }
            selected.push(current);

            return { ...state, selected };
        }
        case SET_UPSELL_OPTIONS: {
            const options = payload as IUpsell[];
            return { ...state, options };
        }
        case CLEAR_SELECTED_UPSELLS: {
            return { ...state, selected: [UpsellType.STANDARD] };
        }
        default:
            return state;
    }
};
